
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisTargetDangerousIec as ObiAisTargetDangerousIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-target-dangerous-iec.js';
 
 
 

 
 export const ObiAisTargetDangerousIec = createComponent({
   react: React,
   tagName: 'obi-ais-target-dangerous-iec',
   elementClass: ObiAisTargetDangerousIecElement,
   events: {
     
   }
  });
 
 